var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}
$(function(){
    //make header sticky
    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        if(scroll > 50){
            $('.main-header').addClass('sticky');
        }
        else{
            $('.main-header').removeClass('sticky');
        }
    });

    //text spinner script
    $('.number-spinner:not(.manual) .counter').click(function(){
        var spinnerDefaultVal = parseInt($(this).closest('.number-spinner').find('.value').val());
        if($(this).hasClass('minus') && spinnerDefaultVal>1){
            spinnerDefaultVal--;
            $(this).closest('.number-spinner').find('.value').val(spinnerDefaultVal);
        }
        else if($(this).hasClass('plus')){
            spinnerDefaultVal++;
            $(this).closest('.number-spinner').find('.value').val(spinnerDefaultVal);
        }
    });

    // $('.number-spinner.manual .counter').click(function(){
    //     var spinnerDefaultVal = parseInt($(this).closest('.number-spinner').find('.value').val());
    //     var _currentVarientId = $(this).data('product-varient-id');
    //     if($(this).hasClass('minus')){
    //         $(this).parent().addClass('loader');
    //         $(this).attr('onclick', `changeItemByVarientId(${_currentVarientId}, ${spinnerDefaultVal-2})`);
    //         $(this).siblings('.plus').attr('onclick', `changeItemByVarientId(${_currentVarientId}, ${spinnerDefaultVal})`);
    //         spinnerDefaultVal--;
    //         $(this).closest('.number-spinner').find('.value').val(spinnerDefaultVal);
    //     }
    //     else if($(this).hasClass('plus')){
    //         $(this).parent().addClass('loader');
    //         $(this).attr('onclick', `changeItemByVarientId(${_currentVarientId}, ${spinnerDefaultVal+2})`);
    //         $(this).siblings('.minus').attr('onclick', `changeItemByVarientId(${_currentVarientId}, ${spinnerDefaultVal})`);
    //         spinnerDefaultVal++;
    //         $(this).closest('.number-spinner').find('.value').val(spinnerDefaultVal);
    //     }
    // });

    $('.btn-with-spinner').on('click', function(){
        var _currentVarientId = $(this).data('product-varient-id');
        $(this).hide();
        $(this).siblings('.number-spinner.manual').removeClass('d-none').find('.cart__qty-input').val(1);
        $(this).siblings('.number-spinner.manual').find('.minus').attr('onclick', `changeItemByVarientId(${_currentVarientId}, 0)`);
        $(this).siblings('.number-spinner.manual').find('.plus').attr('onclick', `changeItemByVarientId(${_currentVarientId}, 2)`);
    });

    //navigation click
    var navOpnFlg=0;
	$(".mobile-trigger").click(function(){
		if(navOpnFlg==0){
            TweenMax.to($(this).find('li:eq(0)'), 0.3, {rotation: -45, x:-3, y: 3, width:"60%"});
            TweenMax.to($(this).find('li:eq(1)'), 0.3, {x:-4, width:"90%"});
            TweenMax.to($(this).find('li:eq(2)'), 0.3, {rotation: 45, x:-3, y: -3, width:"60%"});
            $(".main-nav").addClass("active");
		    navOpnFlg=1;
		}
		else{
            TweenMax.to($(this).find('li:eq(0)'), 0.3, {rotation: 0, x:0, y: 0, width:"100%"});
            TweenMax.to($(this).find('li:eq(1)'), 0.3, {x:0, width:"100%"});
            TweenMax.to($(this).find('li:eq(2)'), 0.3, {rotation:0, x:0, y: 0, width:"100%"});
            setTimeout(function(){$(".main-nav").removeClass("active");},300);
            navOpnFlg=0;
		}
	});

    //global slick slider init
    $(".init-slick").slick();
    //custom arrow buttons
    $('.next-prev-arrow .prev').click(function(){
        var hasManualTrigger = $(this).data('trigger-manual');
        if(typeof hasManualTrigger !== undefined){
            $('.manual-trigger-carousel-'+hasManualTrigger).slick('slickPrev');
        }
	});
	
	$('.next-prev-arrow .next').click(function(){
        var hasManualTrigger = $(this).data('trigger-manual');
        if(typeof hasManualTrigger !== undefined){
            $('.manual-trigger-carousel-'+hasManualTrigger).slick('slickNext');
        }
	});


    //accr script
    $(".accr-wrap .head").click(function () {
        $(this).next(".content").slideToggle().siblings(".content:visible").slideUp();
        $(this).toggleClass("active");
        $(this).siblings(".head").removeClass("active");
    });

    //show cart on click
    $('.main-header .right-nav > ul > li > a.open-cart').click(function(){
        $('.mini-cart-wrap').show();
    });
    $('.mini-cart-wrap .wrap .close').click(function(){
        $('.mini-cart-wrap').hide();
    });
    $(document).mouseup(function(e) 
    {
        var container = $(".mini-cart-wrap");
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
            container.hide();
        }
    });

    //close popup script
    $('.popup-wrap .close').click(function(){
        $('.popup-wrap').hide();
    });

    //activate disc section
    rotateDisc = function(obj){
        $('.buy-product-section-block').addClass('d-none');
        TweenMax.to($('.disc .disc-plate'), 0.5, {rotation: "+="+obj, onComplete: function(){
            var _curr_rotation = gsap.getProperty('.disc-selector .disc #disc', 'rotation');
            var _rotationPos = (_curr_rotation/360%1).toFixed(2);
            if(_rotationPos == 0){
                $('.disc-selector .disc').removeClass('morning day night');
                $('.disc-selector .disc').addClass('morning');
                $('.disc-selector .disc-content').addClass('d-none');
                $('.morning').removeClass('d-none');
            }
            else if(_rotationPos > 0 && _rotationPos <= 0.5){
                $('.disc-selector .disc').removeClass('morning day night');
                $('.disc-selector .disc').addClass('day');
                $('.disc-selector .disc-content').addClass('d-none');
                $('.day').removeClass('d-none');
            }
            else if(_rotationPos > 0.5 && _rotationPos <= 0.7){
                $('.disc-selector .disc').removeClass('morning day night');
                $('.disc-selector .disc').addClass('night');
                $('.disc-selector .disc-content').addClass('d-none');
                $('.night').removeClass('d-none');
            }
        }});
    }
    $('.svg-pie-chart path').click(function(){
        $('.disc-selector .disc').removeClass('active');
        var _curr_rotation_val = $(this).data('rotation');
        rotateDisc(_curr_rotation_val);
    });
    $('.tabs-list ul li').on('click', function(){
        $('.disc-selector .disc').removeClass('active');
        var _currSelection = $(this).data('rotation-trigger');
        rotateDisc(_currSelection);
    });

    //disc section show product detail
    showProductDetail = function(obj, variant){
        $('#hidden-valiant-id').val(variant);
        $('.buy-product-section-block').removeClass('d-none');
        $('.disc-content-product').addClass('d-none');
        $('.'+obj+'-col').removeClass('d-none');
        $('#pick-your-flavour').val(obj);
        $('html,body').animate({ scrollTop: $('.buy-product-section-block').offset().top + 200 }, 600);
    }

    //recover password link click
    $('#RecoverPassword').on('click', function(){
        $('.login-form-wrap').hide();
        $('.forgot-password-form').show();
    });
    $('#HideRecoverPasswordLink').on('click', function(){
        $('.login-form-wrap').show();
        $('.forgot-password-form').hide();
    });
});

//Hardcode products varients
var prod_var_id = [
    {
        "id":39943273545891,
        "name": "Groove"
    },
    {
        "id":39943145062563,
        "name": "Dream"
    },
    {
        "id":39943219347619,
        "name": "Flow"
    },
    {
        "id":39408807379107,
        "name": "Merch Box"
    }
]

//create mini cart line items
function itemsMinicart(cartdata){
    var cartItems = ``;
    cartdata.items.forEach(function (item, index) {
        cartItems += `<li data-cart-item data-cart-item-key="${item.key}" data-cart-item-url="${item.url}" data-cart-item-title="${item.title}" data-cart-item-index="${index+1}" data-cart-item-quantity="${item.quantity}">
                        <div class="image"><img src="${item.featured_image.url}" class="img-fluid" alt=""></div>
                        <div class="name-cart">
                        <div class="name">${item.product_title}</div>
                        <div class="add-more">
                            <div class="number-spinner">
                                <div class="counter minus" onclick="changeItem(${index+1}, ${item.quantity-1})"></div>
                                <input class="value" type="text" value="${item.quantity}">
                                <div class="counter plus" onclick="changeItem(${index+1}, ${item.quantity+1})"></div>
                            </div>
                        </div>
                        </div>
                        <div class="price-action">
                        <div class="price">$${item.original_line_price/100}.00</div>
                        <div class="action"><a href="javascript:;" onclick="changeItem(${index+1}, 0, ${item.variant_id})">Remove</a></div>
                        </div>
                    </li>`
    });
    $('.empty-cart-message').addClass('d-none');
    $('.mini-cart-footer').removeClass('d-none');
    $('.mini-cart-wrap .wrap .subtotal-wrap span').html(`$${cartdata.original_total_price/100}.00`);
    $('.product-list-wrap ul').html(cartItems);
}
function itemsMaincart(cartdata){
    var cartItems = ``;
    cartdata.items.forEach(function (item, index) {
        cartItems += `<div class="row align-items-center py-3 border-row" data-cart-item data-cart-item-key="${item.key}" data-cart-item-url="${item.url}" data-cart-item-title="${item.title}" data-cart-item-index="${index+1}" data-cart-item-quantity="${item.quantity}">
                    <div class="col-lg-7 col-6">
                        <div class="row align-items-center">
                            <div class="col-lg-2 col-5"><img src="${item.featured_image.url}" class="img-fluid" alt=""></div>
                            <div class="col-lg-10"><strong>${item.product_title}</strong></div>
                        </div>
                    </div>
                    <div class="col-lg-5 col-6">
                        <div class="row align-items-center no-gutters">
                            <div class="col-lg-4">
                                <div class="number-spinner">
                                    <div class="counter minus" onclick="changeItem(${index+1}, ${item.quantity-1})"></div>
                                    <input class="value" type="text" value="${item.quantity}">
                                    <div class="counter plus" onclick="changeItem(${index+1}, ${item.quantity+1})"></div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-6 pt-3 pt-lg-0 text-lg-center text-left"><strong>$${item.original_line_price/100}.00</strong></div>
                            <div class="col-lg-5 col-6 pt-3 pt-lg-0 text-right"><a href="javascript:;"  onclick="changeItem(${index+1}, 0)"><strong>Remove</strong></a></div>
                        </div>
                    </div>
                    
                </div>`
    });
    $('.empty-cart-message').addClass('d-none');
    $('.main-cart-footer').removeClass('d-none');
    $('.cart-items .sub-total span').html(`$${cartdata.original_total_price/100}.00 USD`);
    $('.cart-items .items').html(cartItems);
}

function discountCalc(cartdata){
    //get actual count of HERO products
    var totalHeroProds = 0;
    $(cartdata.items).each(function(i){
        if(cartdata.items[i].variant_id == prod_var_id[0].id || cartdata.items[i].variant_id == prod_var_id[1].id || cartdata.items[i].variant_id == prod_var_id[2].id ){
            totalHeroProds+= cartdata.items[i].quantity;
        }
    });
    var _discountAmt = (totalHeroProds-1)*1.5;
    var _tempCartTotalAmt = cartdata.total_price/100;
    var _finalcartAmtAfterDiscount = parseInt(_tempCartTotalAmt) - parseInt(_discountAmt);
    var _decoratedPrice = `<span class="cart-old-price">$${_tempCartTotalAmt}.00</span> <span class="new-price">$${_finalcartAmtAfterDiscount}.00</span>`;
    if(totalHeroProds<2){
        _decoratedPrice = `<span class="new-price">$${_tempCartTotalAmt}</span>`;
    }
    if(totalHeroProds>=3){
        $('.product-list .product-wrapper.gradient').addClass('active');
    }
    else{
        $('.product-list .product-wrapper.gradient').removeClass('active');
    }
    $('.total_price .wrap, .cart-items .sub-total .total_price, .mini-cart-wrap .wrap .subtotal-wrap .total_price').html(_decoratedPrice);
}

//get cart amount on page load
function getCartDetails(){
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cartdata){
            discountCalc(cartdata);
        }
    });
}
getCartDetails();

//free gift logic
var isFreeProductAdded = false;

//add to cart
var addTocartActive = true;
function fastcart(variantId, quantity){
  if(addTocartActive){
    addTocartActive = false;
    $.ajax({
    type: 'POST',
        url: '/cart/add.js',
        data: 'quantity='+quantity+'&id='+variantId,
        dataType: 'json',
        success: function(response){
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function(cartdata){
                    $('.cart-item-count').html(cartdata.item_count);
                        // console.log(cartdata);
                        if(cartdata.item_count === 1){
                            $('.open-cart').trigger('click');
                        }
                        //Free gift logic
                        $('.number-spinner.manual[data-product-varient='+variantId+']').removeClass('loader');
                        itemsMinicart(cartdata);
                        itemsMaincart(cartdata);
                        discountCalc(cartdata);
                        addTocartActive = true;
                        addFreeGiftInit(cartdata);
                        buildSpinner(cartdata);

                        //Freebies added in cart
                        checkFreebiesInCart(cartdata);
                        customAddToCartWrap(cartdata);
                    }
                });
            }
        });
    }
  }
  function addFreeGiftInit(cartdata){
    var totalHeroProds = 0;
    $(cartdata.items).each(function(i){
        if(cartdata.items[i].variant_id == prod_var_id[0].id || cartdata.items[i].variant_id == prod_var_id[1].id || cartdata.items[i].variant_id == prod_var_id[2].id ){
            totalHeroProds+= cartdata.items[i].quantity;
        }
        if(cartdata.items[i].variant_id === prod_var_id[3].id){
            isFreeProductAdded = true;
        }
    });
    if(totalHeroProds >= 3 && !isFreeProductAdded){
        freeGiftIncart(prod_var_id[3].id, 1);
    }
    else if(totalHeroProds < 3 && isFreeProductAdded){
        changeGiftInCartByVarientId(prod_var_id[3].id, 0);
        isFreeProductAdded = false;
    }
  }
  function freeGiftIncart(variantId, quantity){
        // console.log('Check if free gift is added already or not. If not then add the freegift');
        if(addTocartActive){
            addTocartActive = false;
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: 'quantity='+quantity+'&id='+variantId,
                dataType: 'json',
                success: function(response){
                    isFreeProductAdded = true;
                    $.ajax({
                        type: 'GET',
                        url: '/cart.js',
                        dataType: 'json',
                        success: function(cartdata){
                            itemsMinicart(cartdata);
                            itemsMaincart(cartdata);
                            discountCalc(cartdata);
                            addTocartActive = true;
                            $('.cart-item-count').html(cartdata.item_count);
                        }
                    });
                }
            });
        }
  }
  function changeGiftInCartByVarientId(id, quantity){
      if(addTocartActive){
        addTocartActive=false;
        $.ajax({
        type: 'POST',
            url: '/cart/change.js',
            data: 'id='+id+'&quantity='+quantity,
            dataType: 'json',
            success: function(response){
                isFreeProductAdded = false;
                $.ajax({
                    type: 'GET',
                    url: '/cart.js',
                    dataType: 'json',
                    success: function(cartdata){
                        itemsMinicart(cartdata);
                        itemsMaincart(cartdata);
                        discountCalc(cartdata);
                        addTocartActive = true;
                        $('.cart-item-count').html(cartdata.item_count);
                    }
                });
            }
        });
      }
  }


  function changeItem(line, quantity, varientId){
    if(addTocartActive){
    addTocartActive=false;
    $.ajax({
    type: 'POST',
        url: '/cart/change.js',
        data: 'line='+line+'&quantity='+quantity,
        dataType: 'json',
        success: function(response){
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function(cartdata){
                        itemsMinicart(cartdata);
                        itemsMaincart(cartdata);
                        discountCalc(cartdata);
                        addTocartActive=true;
                        // $('.number-spinner.manual[data-product-varient='+variantId+']').removeClass('loader');
                        // $('.total_price').html('$'+cartdata.total_price/100);
                        $('.cart-item-count').html(cartdata.item_count);
                        if(!cartdata.items.length){
                            $('.empty-cart-message').removeClass('d-none');
                            $('.mini-cart-footer, .main-cart-footer').addClass('d-none');
                        }
                        addFreeGiftInit(cartdata);
                        buildSpinner(cartdata);
                        builtAddToCartButtons(cartdata);
                        removeFreebiesInCart(cartdata);
                        customAddToCartWrap(cartdata);
                        $('.add-to-cart-spinner-wrap .number-spinner.manual[data-product-varient='+varientId+']').addClass('d-none');
                        $('.add-to-cart-spinner-wrap .btn[data-product-varient='+varientId+']').removeClass('d-none');
                    }
                });
            }
        });
    }
  }
  function changeItemByVarientId(id, quantity){
      $('.number-spinner.manual[data-product-varient='+id+']').addClass('loader');
      if(addTocartActive){
        addTocartActive=false;
        $.ajax({
        type: 'POST',
            url: '/cart/change.js',
            data: 'id='+id+'&quantity='+quantity,
            dataType: 'json',
            success: function(response){
                $.ajax({
                    type: 'GET',
                    url: '/cart.js',
                    dataType: 'json',
                    success: function(cartdata){
                            // console.log(cartdata);
                            itemsMinicart(cartdata);
                            itemsMaincart(cartdata);
                            discountCalc(cartdata);
                            $('.cart-item-count').html(cartdata.item_count);
                            if(!cartdata.items.length){
                                $('.empty-cart-message').removeClass('d-none');
                                $('.mini-cart-footer, .main-cart-footer').addClass('d-none');
                            }
                            addTocartActive=true;
                            if(quantity!==0){
                                $('.number-spinner.manual[data-product-varient='+id+']').removeClass('loader');
                            }
                            else{
                                $('.number-spinner.manual[data-product-varient='+id+']').addClass('loader d-none');
                                $('.btn-with-spinner[data-product-varient-id='+id+']').removeClass('d-none').show();
                                $('.add-to-cart-spinner-wrap .btn[data-product-varient='+id+']').removeClass('d-none');
                            }
                            //Free gift logic
                            addFreeGiftInit(cartdata);
                            buildSpinner(cartdata);
                            customAddToCartWrap(cartdata);
                        }
                    });
                }
            });
      }
  }

  function buildSpinner(cartdata){
    $(cartdata.items).each(function(i){
        $('.number-spinner.manual[data-product-varient='+cartdata.items[i].variant_id+']').html(`
            <div class="counter minus" data-update-count="0" data-product-varient-id="${cartdata.items[i].variant_id}" onclick="changeItemByVarientId(${cartdata.items[i].variant_id}, ${cartdata.items[i].quantity > 0 ? (parseInt(cartdata.items[i].quantity) - 1) : 0})"></div>
            <input class="cart__qty-input value" type="text" value="${cartdata.items[i].quantity}">
            <div class="counter plus" data-update-count="2" data-product-varient-id="${cartdata.items[i].variant_id}" onclick="changeItemByVarientId(${cartdata.items[i].variant_id}, ${parseInt(cartdata.items[i].quantity) + 1})"></div>
        `);
    });
  }
  function builtAddToCartButtons(cartdata){
    const deleted_variants = prod_var_id.filter(({ id: id1 }) => !cartdata.items.some(({ variant_id: id2 }) => id2 === id1));
    $(deleted_variants).each(function(i){
        $('.number-spinner.manual[data-product-varient='+deleted_variants[i].id+']').addClass('loader d-none');
        $('.btn-with-spinner[data-product-varient-id='+deleted_variants[i].id+']').removeClass('d-none').show();
    });
  }
  //Hardcode freebies products varients
    var prod_free_var_id = [
        {
            "id":39945191030947,
            "name": "Groove"
        },
        {
            "id":39945191096483,
            "name": "Dream"
        },
        {
            "id":39945191063715,
            "name": "Flow"
        }
    ]
  function checkFreebiesInCart(cartdata){
    $(cartdata.items).each(function(i){
        $('.shop-freebies .cover-wrap[data-product-varient='+cartdata.items[i].variant_id+']').find('.btn').attr('onclick','').text('Added to cart');
    });
  }
  function removeFreebiesInCart(cartdata){
    const deleted_variants = prod_free_var_id.filter(({ id: id1 }) => !cartdata.items.some(({ variant_id: id2 }) => id2 === id1));
    $(deleted_variants).each(function(i){
        $('.shop-freebies .cover-wrap[data-product-varient='+deleted_variants[i].id+']').find('.btn').attr('onclick',`fastcart(${deleted_variants[i].id},'1')`).text('Add to cart');
    });
  }
  function customAddToCartWrap(cartdata){
        $(cartdata.items).each(function(i){
            $('.add-to-cart-spinner-wrap .number-spinner.manual[data-product-varient='+cartdata.items[i].variant_id+']').removeClass('d-none');
            $('.add-to-cart-spinner-wrap .btn[data-product-varient='+cartdata.items[i].variant_id+']').addClass('d-none');
        });
  }

